// Third Party library imports
import { Route } from '@angular/router';

// Zopup Library imports
import { LayoutComponent } from '@zopup/zop-ux-layout';

// Internal project imports
import { initialDataResolver } from './app.resolvers';

export const appRoutes: Route[] = [
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('@zopup/zop-ux-verified').then(
                        (m) => m.zopUxVerifiedRoutes
                    ),
            },
        ],
    },
];
